
import Datepicker from "components/DatePicker/DatePicker";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { TabBar } from "components/Tabbar/Tabbar";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useRef, useState } from "react";
import { InvitPeopleForm } from "../InvitedPeopleForm/InvitPeopleForm";
import { getInvitedPersonType } from "./api";
import { convertToISO } from "utils/helpers";
import { InvitedPeopleList } from "../InvitedPeopleList/InvitedPeopleList";
import { useLocation } from "react-router-dom";



export const Invitaion = ({intab="",sourceId,jobId,step,meetingTabPeople, InvitaionFormSubmit,acceptExpireTime ,defaultPeopleList ,mode,formRef ,InvitaionData}) => {


    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState<string | any>([]);
    const [curentTab, setCurentTab] = useState<any>("main")
    const [defaultTab, setDefaultTab] = useState<any>("main")
    const [response, setResponse] = useState<any>()
    const [error, setError] = useState<any>()
    const [usedListId, setUsedListId] = useState<any>([])
    const [invitedPeople, setInvitedPeople] = useState<any>({1:[],2:[],3:[]})
    const invitedPeopleListRef = useRef<any>({1:[],2:[],3:[]});
    const [dateLoading,setDateLoading]=useState(false)
    const acceptExpireDateRef = useRef<any>(null);
  const isCurrent=useLocation()?.pathname?.includes('current')

    function  onSubmit(e){
        e.preventDefault()
        let data = {
            "AcceptExpireTime":acceptExpireDateRef.current, 
            InvitationText:e.target.InvitationText.value,
            InvitedPeople:[...invitedPeopleListRef.current[1],...meetingTabPeople?.Main.map(item=>({...item,InvitedPersonType:item?.InvitedPersonType?item?.InvitedPersonType:1})),...invitedPeopleListRef.current[2],...invitedPeopleListRef.current[3]]
        }
       InvitaionFormSubmit(data)
    }

    
    async function getInvitedPersonTypeAsync() {
        setLoading(false)
               try {
            const res = await getInvitedPersonType()
            setResponse(res.Data)
                        setDefaultTab(Object.values(res.Data)[0])
            setCurentTab(Object.values(res.Data)[0])
            let tabs = Object.keys(res.Data).map(item=>{
                return { title: res.Data[item], body: (<InvitPeopleForm  defaultPeopleList={invitedPeople[res.Data[item]]?.length >0?invitedPeople[res.Data[item]]: defaultPeopleList[res.Data[item]] }  InvitedPersonType={+item} inTab={curentTab ==res.Data[item] } usedListId={usedListId} InvitedListhandler={(e)=>{InvitedListhandler(e,+item)}}showForm={()=>{}} mode={"create"}     />), }
            })
            setContent([
                ...tabs
            ])
           } catch (error:any) {
            setError(error.response?.data.Message)
            
           }
           setLoading(true)
        }
        const tabChangeHandle = (tab) => {
            setCurentTab(tab)
        }
        
        function InvitedListhandler(list , type){
                               const removeDefaultItem =list.filter(item1 => 
     !meetingTabPeople?.Main.some(item2 => item2?.PositionId === item1?.PositionId)
   );
            invitedPeopleListRef.current ={...invitedPeople ,[type]:removeDefaultItem}
            setInvitedPeople({...invitedPeople, [type]:removeDefaultItem})
            let listUsed = usedListId
            list.map(item=>{
                if(!listUsed.includes(item.PositionId)){
                    listUsed.push(item.PositionId)
                }
            })
            setUsedListId(listUsed)
        }

    useEffect(() => {
        if(response && ( mode!='view')){//تسک صدور دعوت نامه مد ویو هست و نباید برای این تسک شرط اجرا بشه بقیه تسک ها مد ادیت و ایجاد هستن و مشکلی ندارد
            let removeDefaultItem
            if(mode!='create' && !invitedPeople?.[1]?.length){
                                    removeDefaultItem =defaultPeopleList?.Main.filter(item1 => 
     !meetingTabPeople?.Main.some(item2 => item2?.PositionId === item1?.PositionId)
   );
            }else{
removeDefaultItem=invitedPeople?.[1]
            }
            
       
     
        
        let tabs = Object.keys(response).map(item=>{
            
                return { title: response[item], body: (<InvitPeopleForm defaultPeopleList={invitedPeople[item]?.length >0?item=="1"?[...removeDefaultItem,...meetingTabPeople?.Main]:invitedPeople[item]: defaultPeopleList[response[item]] } InvitedPersonType={+item} inTab={curentTab ==response[item] } usedListId={usedListId} InvitedListhandler={(e)=>{InvitedListhandler(e,+item)}}showForm={()=>{}} mode={"create"}     />), }
            })
            setContent(tabs)
        }
    }, [curentTab ,defaultPeopleList]);

    useEffect(() => {
        setError(null)
 if(mode!='view')//تسک صدور دعوت نامه مد ویو هست و نباید برای این تسک شرط اجرا بشه بقیه تسک ها مد ادیت و ایجاد هستن و مشکلی ندارد
       { getInvitedPersonTypeAsync();}
    else{
        setLoading(true)
    }
    }, []);

    useEffect(()=>{
        if(InvitaionData?.AcceptExpireTime || acceptExpireTime){
            setDateLoading(true)
        }
    },[InvitaionData?.AcceptExpireTime,acceptExpireTime])
    

    return (
        <>
        {loading ?
            <>
            {error ?
             <Message message={error} type={"error"} />
             : 
             <>

             <form id="invitation" name="invitation" ref={formRef} onSubmit={onSubmit} className="cartable-action">
              <div className="">
        <div className="row">
            <div className="col-lg-12 ">
             <Textbox
              textboxType="textarea"
              textboxName="InvitationText"
              minHeight={3}
              labelText="InvitationText"
              defaultValue={InvitaionData?.InvitationText}
              mode={isCurrent?"edit":'view'}
              />
            </div>
        </div>
  { (dateLoading || mode=='create') && <div className="row">
            <div className="col-lg-3 ">
            <Datepicker
                            mode={isCurrent?"edit":'view'}

               lable="AcceptExpireTime"
               withTime={true}
               onOpenPickNewDate={true}
               setIsoTime={(isoTime: string) => {acceptExpireDateRef.current = isoTime ; }}
               val={InvitaionData?.AcceptExpireTime ? convertToISO(InvitaionData?.AcceptExpireTime)  : null} //resetForm ? new Date().toISOString() : 
               />                          
            </div>
   </div>}
 
           </div>
             {/* <div className="col-lg-12 mt-1 btns_form btnsTabBarFixToTop">
                <Button value={mode=="edit"? "save" : "reference"} btnType="submit" form="InvitaionForm" onClick={formSubmitHandlar} />
                <Button btnType="cancel" value="Cancel" onClick={()=>{}} />
            </div> */}
            {/* //تسک صدور دعوت نامه مد ویو هست و نباید برای این تسک شرط اجرا بشه بقیه تسک ها مد ادیت و ایجاد هستن و مشکلی ندارد */}
              {mode!='view'  ? <TabBar tabChange={tabChangeHandle} content={content} curentTab={curentTab} defaultTab={defaultTab} />
              
              :

     <InvitedPeopleList
            meetingId={sourceId}
            JobId={jobId}
            onHide={() => {}}
            mode={"view"}
         />


              }
         <button  type="submit"  className="d-none" id="hidebutton" name="hidebutton" >
                </button>
            </form>
             

        </>
        }
            </>
            :<Loading/>
        }
        </>

    );
}